import { z } from 'zod';

import { isLsgValidationError } from './isLsgValidationError';

/** Field errors of a refused LSG update, keyed by the camelCase field the API names. */
const FieldErrorsSchema = z.record(z.unknown());

/** Fields a refused LSG update names, as the api-client hands them (camelCase). Empty for any other error. */
export const getLsgFieldErrorKeys = (error: unknown) => {
  if (!isLsgValidationError(error)) {
    return [];
  }

  const fieldErrors = FieldErrorsSchema.safeParse(error.error);

  return fieldErrors.success ? Object.keys(fieldErrors.data) : [];
};
